import React, { useEffect } from "react";
import "./About.css";
import about from "../images/About.webp";

function About() {
     useEffect(() => {
        
            document.title =
              "About - Embarque Services";
        
          }, []);
  return (
<>
    <div className="about-page">

      {/* HERO SECTION */}

      <section className="about-hero">

        <div className="about-overlay">

          <h1>
            About Us
          </h1>

        </div>

      </section>

    </div>

    {/* ABOUT CONTENT SECTION */}

<section className="about-content-section">

  {/* LEFT */}

  <div className="about-content-left">

    <h1>
      Your Trusted <br />
      Repairing Partner
    </h1>

  </div>

  {/* RIGHT */}

  <div className="about-content-right">

    <p>
      Our company provides professional home appliance repair
      and maintenance solutions with experienced technicians.
      We specialize in washing machine, AC, refrigerator,
      TV, microwave oven, water heater, and water purifier services
      with reliable doorstep support across multiple locations.
    </p>

  </div>

</section>

 

{/* <section className="about-counter-section">

  <div className="about-counter-box">

    <h1>
      8+
    </h1>

    <p>
      Years in Business
    </p>

  </div>

  <div className="about-counter-box">

    <h1>
      40000+
    </h1>

    <p>
      Happy Customers
    </p>

  </div>

  <div className="about-counter-box">

    <h1>
      100+
    </h1>

    <p>
       Experienced Technicians 
    </p>

  </div>

  <div className="about-counter-box">

    <h1>
      20
    </h1>

    <p>
      Multiple Service Areas Covered
    </p>

  </div>

</section> */}


{/* <section className="about-engineer-section">


  <div className="about-engineer-image">

    <img
     src={about} alt="repair engineer"
    />

    <div className="about-engineer-overlay">

    </div>

  </div>

  

  <div className="about-engineer-content">

    <h1>
      We, Group Of Engineers, <br />
      providing reliable home <br />
      appliance services
    </h1>

    <p>
      We provide professional and trusted home appliance
      repair solutions with experienced technicians and
      quality service support. Our goal is to deliver
      affordable, fast, and reliable repairing services
      for washing machines, ACs, refrigerators,
      TVs, microwave ovens, water heaters,
      and water purifiers at your doorstep.
    </p>

  </div>

</section> */}

<section className="why-choose-us-section">
  <div className="container">

    <div className="why-choose-header">
      <span>WHY CHOOSE US</span>

      <h2>Reliable Multi-Brand Appliance Service</h2>

      <p>
        Simple and convenient repair and maintenance support for your
        home appliances.
      </p>
    </div>

    <div className="why-choose-grid">

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Experienced Service Team</h3>
          <p>
            Our team handles repair and maintenance requirements for
            different types of home appliances.
          </p>
        </div>
      </div>

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Convenient Service Scheduling</h3>
          <p>
            Service visits can be scheduled based on your location,
            preferred time and technician availability.
          </p>
        </div>
      </div>

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Clear Service Charges</h3>
          <p>
            Applicable service and repair charges are communicated
            before the agreed work is carried out.
          </p>
        </div>
      </div>

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Multi-Brand Appliance Service</h3>
          <p>
            We provide independent repair and maintenance services for
            a range of home appliance brands and models.
          </p>
        </div>
      </div>

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Customer Support</h3>
          <p>
            Our support team assists with service requests, appointment
            scheduling and service-related queries.
          </p>
        </div>
      </div>

      <div className="why-choose-item">
        <div className="why-icon">✓</div>

        <div>
          <h3>Simple Service Process</h3>
          <p>
            From booking to service completion, we keep the process
            straightforward and easy to understand.
          </p>
        </div>
      </div>

    </div>

    <div className="why-contact-box">
      <div>
        <h3>Need Appliance Service?</h3>
        <p>
          Contact our team to discuss your appliance service requirement
          and schedule a visit.
        </p>
      </div>

      <a href="tel:+919363929984" className="why-contact-btn">
        Contact Us Today
      </a>
    </div>

  </div>
</section>


<section className="how-work-section">
  <div className="how-work-container">

    <span className="how-work-label">HOW WE WORK</span>

    <h2>What Happens When You Call</h2>

    <div className="work-steps">

      {/* STEP 1 */}
      <div className="work-step">
        <div className="step-number">1</div>

        <div className="step-content">
          <h3>Call or Book Your Service</h3>

          <p>
            Contact Embarque Services and tell us your appliance type
            and the issue you are experiencing.
          </p>
        </div>
      </div>


      {/* STEP 2 */}
      <div className="work-step">
        <div className="step-number">2</div>

        <div className="step-content">
          <h3>Schedule a Technician Visit</h3>

          <p>
            We arrange a technician visit based on your location,
            service requirement, and available appointment time.
          </p>
        </div>
      </div>


      {/* STEP 3 */}
      <div className="work-step">
        <div className="step-number">3</div>

        <div className="step-content">
          <h3>Appliance Inspection</h3>

          <p>
            Our technician inspects the appliance to identify the
            reported issue and explains the required service or repair.
          </p>
        </div>
      </div>


      {/* STEP 4 */}
      <div className="work-step">
        <div className="step-number">4</div>

        <div className="step-content">
          <h3>Service Charge & Repair Estimate</h3>

          <p>
            Our basic service charge starts from <strong>₹400+</strong>.
            If any spare parts need to be replaced, the spare-part cost
            will be charged additionally.
          </p>
        </div>
      </div>


      {/* STEP 5 */}
      <div className="work-step">
        <div className="step-number">5</div>

        <div className="step-content">
          <h3>Your Approval Before Additional Work</h3>

          <p>
            If additional repair work or spare-part replacement is required,
            our technician will explain the requirement and applicable cost.
            The additional work will proceed only after your approval.
          </p>
        </div>
      </div>

    </div>

  </div>
</section>





<section className="mission-values-section">



  <div className="mission-box">

    <h1>
      Our Mission
    </h1>

    <p>
      We aim to provide reliable and professional
      home appliance repair services with quality workmanship,
      affordable pricing, and trusted customer support.
      Our mission is to deliver fast doorstep solutions
      for every customer while maintaining service excellence
      and long-term customer satisfaction.
    </p>

  </div>

  {/* RIGHT */}

  <div className="values-box">

    <h1>
      Core Values
    </h1>

    <div className="value-item">

      <span>
        ✔
      </span>

      <p>
        We believe honesty and transparency build strong customer trust.
      </p>

    </div>

    <div className="value-item">

      <span>
        ✔
      </span>

      <p>
        We focus on providing the right repair solutions for every issue.
      </p>

    </div>

    <div className="value-item">

      <span>
        ✔
      </span>

      <p>
        We deliver high-quality service with experienced technicians.
      </p>

    </div>

  </div>

</section>
<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>


<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

    </>

  );
}

export default About;